// extracted by mini-css-extract-plugin
module.exports = {"component":"FilterGroupBox_component__fstue","label":"FilterGroupBox_label__ehGH7","content":"FilterGroupBox_content__nQ2OM"};